import { authenticatedFetch } from '../../../api/utils/request';

export default async function getDoctorUserStatusCatalog(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener el catálogo de estados de usuario');
    return await authenticatedFetch('/admin-setup/doctor-user-status', onError);
}
